export const GoogleMapsUtils = {

    getSearch(latitude: number, longitude: number): string {
        return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    },
}
